import { React, useEffect, useState, useRef } from "react";
import './Dashboard.scss'
import axios from "axios";
import starterImage from "../../images/Starter.svg";
import basicImage from "../../images/basic.svg";
import proImage from "../../images/pro.svg";
import liteImage from "../../images/lite.svg";
import enterpriseImage from "../../images/Enterprise.svg";
import ultimateImage from "../../images/ultimate.svg";
import defaultLogo from '../../images/default_logo.jpg';
import leftArrow from '../../images/Left-arrow.svg';
import rightArrow from '../../images/right-arrow.png';
import arrow from '../../images/Arrow-knowmore.svg';
import moment from 'moment';
import { Route, Navigate, useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
// import { useSelector } from "react-redux";
// import "./DashBoard.scss";
// import { useDispatch } from "react-redux";
// import { sidebarReducer } from "../../Redux/store";
// import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// import MuiToggleButton from "@mui/material/ToggleButton";

// import { styled, createTheme, ThemeProvider } from "@mui/material/styles";

import ImageComponent from "../../components/Image/ImageComponent"
import BundleImage from "../../components/Image/BundleImageComapnent"

import {
  Chart,
  LinearScale,
  CategoryScale,
  ArcElement,
  BarElement,
  Legend,
  Tooltip,
  Title,
} from "chart.js";

Chart.register(
  LinearScale,
  CategoryScale,
  ArcElement,
  BarElement,
  Legend,
  Title,
  Tooltip
);

const DashBoard = () => {
  const [availableBundles, setAvailableBundles] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [numLogosDisplayed, setNumLogosDisplayed] = useState(5);
  const containerRef = useRef(null);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyID, setCompanyID] = useState([0]);

  const[image,setImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [bundleDetails, setBundleDetails] = useState([]);
  const navigate = useNavigate();



  useEffect(() => {
    getMasterCompanyDetails();
    getAllMasterPacks();
   

  }, []);



  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1080) {
        console.log(">1080")
        setNumLogosDisplayed(5);
      }
    
      else if (window.innerWidth < 1080 && window.innerWidth >= 840) {
        console.log("1080")
        setNumLogosDisplayed(4);
      }
      else if (window.innerWidth < 840) {
        console.log("840")
        setNumLogosDisplayed(3);
      }

      ;
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener(
        'resize'
        , handleResize);
    };
  });

  const getAllMasterPacks = async () => {


    try {
      const response = await axios.get(
        '/v1/masterpack/listAllPacks', {
        headers: {
          'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
        }
      }
      );

      const data = response.data.data;

      if (data.length > 0) {
        setAvailableBundles(data);
        // console.log("jwerhjirgter",data)
      } else {
        console.error("Invalid server response format:", data);
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
    }


  };


  const getImageSrc = (te_bundlename) => {
    switch (te_bundlename) {
      case "Starter":
        return starterImage;
      case "Basic":
        return basicImage;
      case "Lite":
        return liteImage;
      case "pro":
        return proImage;
      case "Enterprise":
        return enterpriseImage;
      case "dummy":
        return ultimateImage;
      default:
        return "";
    }
  };


  // const getMasterCompanyDetails = async () => {
  //   try {
  //     const response = await axios.get(
  //       '/v1/companyprofile/list', {
  //       headers: {
  //         'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
  //       }
  //     }
  //     );
  //     const data = response.data.data.rows;

  //     if (data.length > 0) {
  //       setCompanies(data);
  //       // console.log("image data",getBlobUrl(data[2].te_companylogosmall))
  //       setImage(data[2].te_companylogosmall)
  //       setSelectedCompany(data[0]);
       

  //     } else {
  //       console.error("Invalid server response format:", data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching company details:", error);
  //   }

  // };



  const handleNext = () => {
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, companies.length - numLogosDisplayed));
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };



  // const handleImageClick = async (index) => {
  //   setSelectedCompany(companies[index]);
    

  //   const companyId = companies[index].te_companyid;
  //   try {
  //     const response = await axios.get(`/v1/licensedetails/CompanyLicenselistbyid/${companyId}`, {
  //       headers: {
  //         'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
  //       }
  //     });
  //     const data = response.data.data;
  //     setBundleDetails(data);
  //     console.log("bundleDetails",bundleDetails)
  //   } catch (error) {
  //     console.error("Error fetching bundle details:", error);
  //   }
  // };

  const fetchBundleDetails = async (companyId) => {
    try {
      const response = await axios.get(`/v1/licensedetails/CompanyLicenselistbyid/${companyId}`, {
        headers: {
          'Authorization': 'Bearer ' + sessionStorage.getItem("access_token"),
        }
      });
      const data = response.data.data;
      setBundleDetails(data);
    } catch (error) {
      console.error("Error fetching bundle details:", error);
    }
  };
  const getMasterCompanyDetails = async () => {
    try {
      const response = await axios.get(
        '/v1/companyprofile/list', {
        headers: {
          'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
        }
      }
      );
      const data = response.data.data.rows;
  
      if (data.length > 0) {
        setCompanies(data);
        setImage(data[2].te_companylogosmall)
        setSelectedCompany(data[0]);
        
        // Fetch bundle details for the first company
        await fetchBundleDetails(data[0].te_companyid);
      } else {
        console.error("Invalid server response format:", data);
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return moment(date).format('DD-MMM-YYYY');
  };

  // const calculateDaysBetween = (startDate, endDate) => {
  //   const start = moment(startDate);
  //   const end = moment(endDate);
  //   return end.diff(start, 'days')+1;
  // };
  const calculateDaysToExpiration = (activationDate, expirationDate) => {
    const today = moment().startOf('day');
    const activation = moment(activationDate).startOf('day');
    const expiration = moment(expirationDate).endOf('day');
    
    if (today.isBefore(activation)) {
      return expiration.diff(activation, 'days') + 1;
    } else {
      return Math.max(0, expiration.diff(today, 'days') + 1);
    }
  };
  const handleImageClick = async (index) => {
    setSelectedCompany(companies[index]);
    const companyId = companies[index].te_companyid;
    await fetchBundleDetails(companyId);
  };

  return (
    <div>

      <div className="DashBoard">
        <div>
          <div >

            <div
              className="row g-0 p-0"
            >
              <div className="d-flex ">
                <h5 style={{ marginRight: "auto", fontSize: "35px" }}>
                  User Dashboard
                </h5>
              </div>

            </div>
            <div className="dashboard-container"  >

              <div className="bundle-display">
                <p className="headings">Latest Software's</p>
                <div className="bundle-data-display" style={{ overflowY: "auto"}}>
                  {availableBundles.length === 0 ? (
                    <div className="col text-center">
                      <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", marginTop: "100px" }}>
                        <CircularProgress color="inherit" />
                      </Box>
                    </div>
                  ) : (
                    <div className=" row m-0 d-flex align-item-center justify-content-center " style={{width:"99%",height:"inherite"}}>

                      {availableBundles.map((bundle, index) => (

                        <div key={index}
                          className="p-0 d-flex align-item-center justify-content-center "
                          style={{  width: "12vw", height: '12vw',display: "flex", flexDirection: "column" ,alignItems:"center"}}>
                          {/* <p className="mb-0">{bundle.te_bundlename}</p> */}
                          <BundleImage className="bundle-pack" style={{ width: "10vw", height: 'auto'}} image={bundle.te_softwarelogo} />
                          {/* <img style={{ width: "10vw", height: 'auto' }}
                            className="bundle-pack"
                            src={getImageSrc(bundle) != "" ? getImageSrc(bundle) != "" : require("../../images/basic.png")}
                            alt={`Bundle ${bundle}`}
                          /> */}

                        </div>
                      ))}
                    </div>
                  )}

                </div>
                <div>
                  <button className="button-knowmore" onClick={() => { navigate('/Software') }}>
                    Know More
                    <img src={arrow} className="know-arrow"></img>
                  </button>
                </div>
              </div>
              <div className="companies-logo">
                <p className="headings">On Boarded Companies</p>
                <div className="company-logos-container">
                  <button className="nav-btn prev" onClick={handlePrev} disabled={currentIndex === 0}>
                    <img src={leftArrow} className="shift-arrow" alt="Previous" />
                  </button>
                  {companies.length === 0 ? (
                    <div className="col text-center">
                      <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", marginTop: "100px" }}>
                        <CircularProgress color="inherit" />
                      </Box>
                    </div>
                  ) : (
                    <div className="company-logos-wrapper">
                      {companies.slice(currentIndex, currentIndex + numLogosDisplayed).map((company, index) => (
                        <div key={index} className="company-logo">
                          <div className={`rounded-box ${selectedCompany && selectedCompany.te_companyid === company.te_companyid ? 'selected' : ''}`}
                            onClick={() => handleImageClick(index + currentIndex)}>
                            {company.te_companylogosmall ? (<>
                              <ImageComponent image={company.te_companylogosmall} />
                            
                            </>) : (
                              <div className="default-logo">
                                <img className="image-size" src={defaultLogo} alt="Default Logo" />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <button className="nav-btn next" onClick={handleNext} disabled={currentIndex + numLogosDisplayed >= companies.length}>
                    <img src={rightArrow} className="shift-arrow" alt="Next" />
                  </button>
                </div>
              </div>



              <div className="companies-details">
                <p className="heading" style={{ borderBottom: "2px solid #334456",padding:"15px 0px 10px 25px" }}>
                  {selectedCompany ? selectedCompany.te_companyname : ''}
                </p>
                <div className="License-design">
                  <table style={{ width: "100%" }}>
                    <thead className="table-head">
                      <tr>
                        <th style={{ padding: "10px" }}>No</th>
                        <th style={{ padding: "10px" }}>Software</th>
                        <th style={{ padding: "10px" }}>No of Users</th>
                        <th style={{ padding: "10px" }}>Issue Date</th>
                        <th style={{ padding: "10px" }}>Expiry Date</th>
                        <th style={{ padding: "10px" }}>Status</th>
                        <th style={{ padding: "10px" }}>Attention Required</th>
                      </tr>
                    </thead>
                    <tbody className="table-body" >
                      {Array.isArray(bundleDetails) && bundleDetails.length > 0 ? (
                        bundleDetails.map((bundle, index) => (
                          <tr key={index} style={{ borderBottom: "2px solid #334456" }}>
                            <td style={{ padding: "10px" }}>{bundle.te_licenseno}</td>
                            <td style={{ padding: "10px" }}>{bundle.master_pack.te_bundlename} </td>
                            <td style={{ padding: "10px" }}>{bundle.te_licenseusedbyusers}</td>
                            <td style={{ padding: "10px" }}>{formatDate(bundle.te_licenseactivationdate)}</td>
                            <td style={{ padding: "10px" }}>{formatDate(bundle.te_licenseexpirationdate)}</td>
                            <td style={{ padding: "10px" }}>{bundle.te_islicenseactivated ? 'Active' : 'Inactive'}</td>
                          
                            <td style={{ padding: "10px", color: "#B6094C" }}>
                              {calculateDaysToExpiration(bundle.te_licenseactivationdate, bundle.te_licenseexpirationdate) > 0 ? (
                                <>
                                  Expires in <span> </span>
                                  {calculateDaysToExpiration(bundle.te_licenseactivationdate, bundle.te_licenseexpirationdate)}
                                  <span> </span>days
                                </>
                              ) : (
                                "Expired"
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" style={{ textAlign: "center", color: "#B6094C" }}>No licenses found for this company</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>


            </div>



          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoard;
